(function ($) {
    $(function () {
        var togglerHeightInPx = 22;
        var lineHeightInPx = 22;
        var maxDesiredOverflowHeight = lineHeightInPx * 6;

        function isImageLoaded(image) {
            return image.complete && image.naturalHeight !== 0;
        }

        function calculateHeight($widgets) {
            $widgets.each(function (i, el) {
                var $el = $(el);
                var $image = $el.find('.press-article-image');

                var imageLoaded = isImageLoaded($image[0]);
                if (!imageLoaded) {
                    return;
                }

                var imageHeight = $image.height();

                var $preamble = $el.find('.press-article-preamble');
                var preambleHeight = $preamble.height();

                var $overflow = $el.find('.press-article-description-overflow');
                var overflowHeight = $overflow.height();

                var $overflowContainer = $el.find('.press-article-description-overflow-container');
                var isOverflowEnabled = $overflowContainer.hasClass('enabled');

                var desiredOverflowHeight = Math.min(imageHeight - preambleHeight, overflowHeight + togglerHeightInPx);

                var isOverflowRequired = (overflowHeight + togglerHeightInPx) > desiredOverflowHeight;
                if (window.innerWidth < 992 || desiredOverflowHeight > maxDesiredOverflowHeight) {
                    desiredOverflowHeight = maxDesiredOverflowHeight;
                    isOverflowRequired = (overflowHeight + togglerHeightInPx) > desiredOverflowHeight;
                }

                var $toggler = $el.find('.description-overflow-toggler');
                if (isOverflowEnabled) {
                    $toggler.html(isOverflowRequired ? $toggler.data('more-text') : '');
                } else {
                    $toggler.html(isOverflowRequired ? $toggler.data('less-text') : '');
                }

                if (isOverflowEnabled) {
                    var heightToSet = Math.floor(desiredOverflowHeight - togglerHeightInPx);

                    var moduloResult = heightToSet % lineHeightInPx;
                    if (moduloResult <= (lineHeightInPx - 6)) {
                        heightToSet -= moduloResult;
                        $toggler.css('margin-top', moduloResult);
                    } else {
                        $toggler.css('margin-top', 0);
                    }

                    $overflowContainer.height(heightToSet);
                } else {
                    $overflowContainer.height(overflowHeight);
                }
            });
        }

        var $widgets = $('.press-article-widget');

        $widgets.each(function (i, el) {
            var $el = $(el);

            var $image = $el.find('.press-article-image');
            if (isImageLoaded($image[0])) {
                calculateHeight($el);
            } else {
                $image.bind('load', function () {
                    calculateHeight($el);
                });
            }

            var $toggler = $el.find('.description-overflow-toggler');
            $toggler.bind('click', function (e) {
                e.preventDefault();

                var $overflowContainer = $el.find('.press-article-description-overflow-container');
                $overflowContainer.toggleClass('enabled');
                calculateHeight($el);
            });
        });

        $(window).on('resize', function () {
            calculateHeight($widgets);
        });
    });
})(window.jQuery);